export default class SubClinics {
    constructor() {
        async function initMenu() {
            
            const menu = document.querySelector('.submenu__links--sub-clinics');
            if (!menu) {
                return;
            }
            const currentClinic = menu.querySelector('.submenu__link--active');
            if (!currentClinic) {
                return;
            }
            currentClinic.addEventListener('click', (e) => {
                menu.classList.toggle('is-active');
            });

        }

        initMenu();
    }
}
